import React, { useContext, useEffect } from 'react';
import '../../styles/Header.css';
import logo from '../../assets/icons/NewLogo.png';
import OverlayMenu from '../../features/home/components/OverlayMenu';
import { WebSocketContext } from '../../stores/websocketContext';
import { FaWifi, FaBan } from "react-icons/fa";

function Header({ isActive, setIsActive, connectionStatus }) {
  const handleHamburgerClick = () => {
    setIsActive(true);
  };

  const { isConnected, globalConnectionStatus } = useContext(WebSocketContext);

  const currentConnectionStatus =
    connectionStatus || globalConnectionStatus || 'Disconnected';

  useEffect(() => {
    console.log('Header connected value is', isConnected);
    console.log('Header connectionStatus is', currentConnectionStatus);
  }, [isConnected, currentConnectionStatus]);

  return (
    <React.Fragment>
      <header className="app-header">
        <div className="left-section">
          <button className="custom-hamburger" onClick={handleHamburgerClick}>
            <span className="bar top"></span>
            <span className="bar middle"></span>
            <span className="bar bottom"></span>
          </button>
        </div>

        <div className="center-section">
          <img src={logo} alt="PrashaSync Logo" className="logo-icon" />
        </div>

        <div className="right-section">
          {currentConnectionStatus === "Connected" ? (
            <FaWifi className="status-icon connected" title="Connected" />
          ) : (
            <FaBan className="status-icon disconnected" title="Disconnected" />
          )}
        </div>
      </header>

      <OverlayMenu isActive={isActive} setIsActive={setIsActive} />
    </React.Fragment>
  );
}

export default Header;
